<section
  class="user-profile-collections-subpage profile-section"
  [class.mobile]="deviceService.isMobile()"
  [class.tablet]="deviceService.isTablet()">
  <section class="user-profile-collections-subpage__section" rel="collections">
    <app-title [title]="'user-profile.title-collections'"></app-title>

    <ng-container *ngIf="collections$ | async as collectionsState">
      <ng-container *ngIf="collectionsState.loaded">
        <ng-container *ngIf="collections.length; else emptyCollections">
          <div
            *ngFor="let collection of collections; trackBy: trackContentByFn"
            class="user-profile-collections-subpage__scroll-item">
            <app-collection-card-mini
              [displayMode]="'default'"
              [collection]="collection"
              [linkEnable]="false"
              (action)="onAction()"
              (openInModal)="onOpenCard($event)">
            </app-collection-card-mini>
          </div>
        </ng-container>

        <ng-template #emptyCollections>
          <div class="user-profile-collections-subpage__empty-content">
            <app-empty *ngIf="isMe" [empty]="emptyCollectionObj"></app-empty>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </section>
</section>

<ng-container *ngIf="showModal">
  <app-modal *ngIf="deviceService.isDesktop()" (closed)="onCloseCard()">
    <app-modal-body>
      <article rel="main">
        <app-collection-card [collection]="item" [meta]="true" (isCloseAllModals)="onCloseCard()" [modal]="true">
        </app-collection-card>
      </article>
    </app-modal-body>
  </app-modal>

  <app-mobile-modal *ngIf="!deviceService.isDesktop()" (closed)="onCloseCard()">
    <app-mobile-modal-title>{{ 'collections.collection' | translate }}</app-mobile-modal-title>

    <app-mobile-modal-body>
      <article rel="main">
        <app-collection-card [collection]="item" [meta]="true" [modal]="true"> </app-collection-card>
      </article>
    </app-mobile-modal-body>

    <app-mobile-modal-actions></app-mobile-modal-actions>
  </app-mobile-modal>
</ng-container>
